<template>
  <div class="ship">
    <div class="ship_nav">
      <navbar
        :title="type"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <van-row class="show_address_row">
        <van-col span="24" class="show_address">
          <span class="address">
            <img
              src="../../../assets/purchaseSupplier/common/address.png"
              alt=""
            />
          </span>
          <p class="name">
            {{ addressInfo.consignee
            }}<span>{{ addressInfo.consignee_mobile }}</span>
          </p>
          <p class="site" ref="copytxt">
            {{ addressInfo.address_name + addressInfo.address }}
            <img
              src="../../../assets/purchaseSupplier/common/copy.png"
              @click="copyCode()"
            />
          </p>
        </van-col>
      </van-row>
      <van-row class="logistic_info">
        <van-col span="24" class="item" @click="showExpress">
          <span class="label">物流公司</span>
          <span class="_select" v-if="!expressValue">请选择物流公司</span>
          <span class="_select val" v-else>{{ expressValue }}</span>
          <van-icon name="arrow" />
        </van-col>
        <van-col span="24" class="item _express">
          <van-field
            v-model="express"
            label="物流单号"
            placeholder="请填写物流编号"
            input-align="right"
          />
        </van-col>
      </van-row>
      <van-row class="submit_btn">
        <van-col span="24">
          <btn
            :btntext="'提交'"
            :btnwidth="'34.3rem'"
            :height="'5rem'"
            :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
            :borderradius="'0.4rem'"
            :btncolor="'#fff'"
            :fontsize="'1.8rem'"
            :fontweight="700"
            @btnClick="submit"
          />
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      express: "", //物流单号
      expressValue: "", //物流公司中文名
      addressInfo: {},
      selectItem: {},
      type:''
    };
  },
  beforeDestroy(){
    localStorage.removeItem("selectAddress");
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  created() {
    this.addressInfo = JSON.parse(localStorage.getItem("addressInfo"));
    this.type = this.$route.query.type == '0'?'立即发货':'修改物流';
    this.selectItem = JSON.parse(localStorage.getItem("selectAddress"));
    if (this.selectItem) this.expressValue = this.selectItem.name;

    if(this.$route.query.type== '1'){
      let logistic_info = JSON.parse(localStorage.getItem("logisticsInfo"));
      
      if(!this.selectItem){
         this.selectItem = {
          id:'',
          name: logistic_info[0].post_name,
          code: logistic_info[0].post_code
        }
        this.expressValue = this.selectItem.name;
      }
      
      this.express = logistic_info[0].post_no;
    }
  },
  methods: {
    goBack() {

      this.$router.go(-1);
    },
    copyCode() {
      const rechage_range = document.createRange();
      rechage_range.selectNode(this.$refs.copytxt);
      const rechage_selection = window.getSelection();
      if (rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
      rechage_selection.addRange(rechage_range);
      document.execCommand("Copy");
      this.$toast("复制成功");
      rechage_selection.removeAllRanges();
    },
    submit() {
      if (this.selectItem.id||this.selectItem.name) {
        this.expressValue = this.selectItem.name;
      } else {
        this.$toast("请选择收货地址");
        return;
      }
      let url = "/onorder/member/order/supplier/deliver/goods";
      if(this.$route.query.type== '1'){
        url = "onorder/member/order/supplier-modify-logistics";
      }
      this.$api.post(url, {
          order_id: this.$route.query.orderid,
          order_goods_id: this.$route.query.type== '1'?this.$route.query.goodsid:[this.$route.query.goodsid],
          post_name: this.selectItem.name,
          post_code: this.selectItem.code,
          post_no: this.express,
        })
        .then((res) => {
          if(this.$route.query.type== '1'){
            this.$toast("修改成功");
          }else{
            this.$toast("发货成功");
          }
          this.$router.go(-1);
        }).catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    showExpress() {
      this.$router.push("/purchaseSupplier/logistics");
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.ship {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .ship_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #ffffff;
    z-index: 3;
  }

  .box {
    padding: 10rem 0 0;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .show_address_row {
      min-height: 7.7rem;
      background: #fff;
      margin-bottom: 1.2rem;
      padding: 1.2rem 0;
      box-sizing: border-box;

      .show_address {
        min-height: 5.3rem;
        margin-bottom: 0;
        padding: 0 2.1rem 0 6.3rem;
        background: #fff;
        text-align: left;
        position: relative;
        box-sizing: border-box;

        .address {
          width: 6.3rem;
          padding-left: 1.6rem;
          min-height: 5.3rem;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          display: flex;
          align-items: center;
          box-sizing: border-box;

          img {
            width: 3.6rem;
          }
        }

        .name {
          color: #333;
          font-size: 1.7rem;
          height: 2.6rem;
          line-height: 2.6rem;
          margin-bottom: 0.5rem;

          span {
            color: #999;
            margin-left: 1.6rem;
          }
        }

        .site {
          color: #333;
          font-size: 1.7rem;
          line-height: 2.4rem;
          font-weight: 700;
          padding-right: 3.4rem;
          position: relative;

          img {
            width: 2rem;
            position: absolute;
            right: 0;
            top: 0;
          }
        }
      }
    }

    .logistic_info {
      min-height: 8.2rem;
      background: #fff;
      padding: 0.7rem 1.5rem;
      color: #333;
      font-size: 1.7rem;
      box-sizing: border-box;
      font-weight: 700;

      .item {
        line-height: 3.4rem;

        span {
          display: inline-block;
          width: calc(100% - 12.3rem);
          text-align: right;
        }

        ._select {
          width: calc(100% - 14.5rem);
          color: #c0c0c0;
          font-weight: 400;
          text-align: left;
        }

        .label {
          width: 9rem;
          text-align: left;
        }

        .van-icon {
          float: right;
          color: #c0c0c0;
          width: 1.6rem;
          margin-top: 0.9rem;
        }

        .val {
          color: #333;
        }
      }

      ._express {
        .van-cell {
          padding: 0;
          font-size: 1.7rem;
          font-weight: 700;

          /deep/.van-field__label {
            width: 9rem !important;
            margin-right: 0;
            color: #333;
          }

          /deep/.van-cell__value {
            padding-right: 1.6rem;
            font-weight: 400;
            .van-field__control--right {
              text-align: left;
            }
          }
        }
      }
    }

    .submit_btn {
      padding: 4rem 1.6rem;
    }
  }
}
</style>